import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-four-circles",
  "use": "foquz-icon-four-circles-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-four-circles\"><path d=\"M6 3.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm0 9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm9-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm0 9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z\" stroke=\"currentColor\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol